"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _flex = _interopRequireWildcard(require("../../flex"));

var _icon = _interopRequireDefault(require("../../icon"));

var _defaults = _interopRequireDefault(require("../../theme-provider/defaults"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = (
/*#__PURE__*/
0, _styledBase.default)(_flex.default, {
  target: "e141r7tq0"
})(function (props) {
  return "\n    background-color: ".concat(props.theme.colors.info[3], ";\n    padding: ").concat(props.theme.spacing[2], "px ").concat(props.theme.spacing[1], "px;\n    margin-bottom: ").concat(props.theme.spacing[1], "px;\n    border-radius: ").concat(props.theme.container.radius[1], "px;\n  ");
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mcm9hbGEvY29tcG9uZW50cy9zYXZlLXJlbWluZGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU00QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvZnJvYWxhL2NvbXBvbmVudHMvc2F2ZS1yZW1pbmRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgRmxleCwgeyBCb3ggfSBmcm9tICcuLi8uLi9mbGV4JztcbmltcG9ydCBJY29uIGZyb20gJy4uLy4uL2ljb24nO1xuaW1wb3J0IGRlZmF1bHRzIGZyb20gJy4uLy4uL3RoZW1lLXByb3ZpZGVyL2RlZmF1bHRzJztcblxuY29uc3QgV3JhcHBlciA9IHN0eWxlZChGbGV4KWBcbiAgJHtwcm9wcyA9PiBgXG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHtwcm9wcy50aGVtZS5jb2xvcnMuaW5mb1szXX07XG4gICAgcGFkZGluZzogJHtwcm9wcy50aGVtZS5zcGFjaW5nWzJdfXB4ICR7cHJvcHMudGhlbWUuc3BhY2luZ1sxXX1weDtcbiAgICBtYXJnaW4tYm90dG9tOiAke3Byb3BzLnRoZW1lLnNwYWNpbmdbMV19cHg7XG4gICAgYm9yZGVyLXJhZGl1czogJHtwcm9wcy50aGVtZS5jb250YWluZXIucmFkaXVzWzFdfXB4O1xuICBgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgKHsgc2hvdyB9KSA9PlxuICBzaG93XG4gICAgPyA8V3JhcHBlciBqdXN0aWZ5Q29udGVudD1cInNwYWNlLWJldHdlZW5cIj5cbiAgICAgIDxGbGV4IGFsaWduSXRlbXM9XCJjZW50ZXJcIj5cbiAgICAgICAgPEljb24gaWNvbj1cImluZm8tY2lyY2xlXCIgd2lkdGg9XCIyNHB4XCIgZmlsbD17ZGVmYXVsdHMuY29sb3JzLmluZm9bMF19IC8+XG4gICAgICAgIDxCb3ggbWw9ezJ9PlxuICAgICAgICAgIDxGbGV4IGFsaWduSXRlbXM9XCJjZW50ZXJcIj5cbiAgICAgICAgICAgIDxzcGFuPk1ha2Ugc3VyZSB0byBhcHBseSB5b3VyIGNoYW5nZXMgYnkgY2xpY2tpbmcmbmJzcDs8L3NwYW4+XG4gICAgICAgICAgICA8SWNvbiBpY29uPVwiYW5nbGUtYnJhY2tldHNcIiB3aWR0aD1cIjI0cHhcIiAvPlxuICAgICAgICAgIDwvRmxleD5cbiAgICAgICAgPC9Cb3g+XG4gICAgICA8L0ZsZXg+XG4gICAgPC9XcmFwcGVyPlxuICAgIDogbnVsbDtcbiJdfQ== */");

var _default = function _default(_ref) {
  var show = _ref.show;
  return show ? (0, _core.jsx)(Wrapper, {
    justifyContent: "space-between"
  }, (0, _core.jsx)(_flex.default, {
    alignItems: "center"
  }, (0, _core.jsx)(_icon.default, {
    icon: "info-circle",
    width: "24px",
    fill: _defaults.default.colors.info[0]
  }), (0, _core.jsx)(_flex.Box, {
    ml: 2
  }, (0, _core.jsx)(_flex.default, {
    alignItems: "center"
  }, (0, _core.jsx)("span", null, "Make sure to apply your changes by clicking\xA0"), (0, _core.jsx)(_icon.default, {
    icon: "angle-brackets",
    width: "24px"
  }))))) : null;
};

exports.default = _default;